import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';
import { siteConfig } from '@/mocks/site';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 text-primary-400 hover:text-primary-300 transition-colors mb-4">
                <i className="ri-fire-fill text-xl w-5 h-5 flex items-center justify-center"></i>
                <span className="font-heading text-lg font-bold">小辣椒影院</span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                {siteConfig.tagline}
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-label text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">影视分类</h4>
              <nav className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </nav>
            </div>

            {/* About */}
            <div>
              <h4 className="font-label text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">关于我们</h4>
              <nav className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  用户口碑
                </Link>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </nav>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-label text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">联系方式</h4>
              <div className="flex flex-col gap-2 text-sm text-background-400">
                <span className="flex items-center gap-2">
                  <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                  {siteConfig.email}
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                  {siteConfig.phone}
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                  {siteConfig.address}
                </span>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {currentYear} 小辣椒影院 版权所有 | 京ICP备2024000001号
            </p>
            <div className="flex items-center gap-4 text-sm text-background-500">
              <span className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</span>
              <span className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</span>
              <span className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}